module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_8.67730dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_8.jpg
// module id = Jace
// module chunks = 0